// extracted by mini-css-extract-plugin
export default {"fileInput":"JamatPage_fileInput__fUKGy","monthRow":"JamatPage_monthRow__DlDfO","months":"JamatPage_months__rlR25","help":"JamatPage_help__WQrcZ","footer":"JamatPage_footer__NEdWm"};